/**
 * @bref    Fonctionnalitées jQuery relatives au plugin Datatable.
 * @remark  Fichier appelé dans un bloc jQuery.
 */

//#####################################################
// For table pagination
//#####################################################

// Get active language file
var lang = ($('html').attr('lang') || 'fr');
var language = require('./i18n/' + lang + '.json');
language.search            = '';
language.searchPlaceholder = lang === 'fr' ? "Rechercher..." : "Search...";
language.paginate.previous = '<i class="bi bi-chevron-left"></i>';
language.paginate.next     = '<i class="bi bi-chevron-right"></i>';

$('.mytable').DataTable ({
    searching: false,
    "dom": '<"top">rt<"bottom"flp i p><"clear">',
    "pagingType": "simple",
    "language": language
});

// Activate the datatable search
var dataTable = $('.table-search').DataTable({
    "dom": '<"top">rt<"bottom"flp i p><"clear">',
    "pagingType": "simple",
    "language": language
});

$('#dataTable_filter input').on('keyup', function() {
    var searchText = $(this).val();

    dataTable.search(searchText).draw();
});

//Fix issue from bootstrap - For dropdown inside table - Overlap the responsive
var dropdownElementList = [].slice.call(
    document.querySelectorAll("body .dropdown-toggle")
);

dropdownElementList.forEach(function (dropdownToggleEl) {
    new bootstrap.Dropdown(dropdownToggleEl, {
        boundary: document.querySelector("body"),
        popperConfig: function (defaultBsPopperConfig) {
            return Object.assign({}, defaultBsPopperConfig, { strategy: "fixed" });
        }
    });
});
